import { createV3Queries } from "@query/utils/createV3Queries";
import { payeeEngagementsApi } from "@api";

/**
 * Payee-engagement (relationship) registry — mirrors `PayeeEngagementsApi` 1:1.
 * Read-only usage today: the contractor detail hub reads
 * `listPayeeEngagements` to surface engagement-level completeness
 * (`PayeeEngagement.areAllRequirementsComplete`) in the details alerts. The
 * name-derived defaults cover sibling read invalidation; no cross-resource
 * config is needed yet.
 */
export const queriesPayeeEngagements = createV3Queries(
  "payeeEngagementsApi",
  payeeEngagementsApi
);
